// extracted by mini-css-extract-plugin
export default {"about":"About_about__pW+5L","about__bottomPanel":"About_about__bottomPanel__-i1hd"};